import styled from 'styled-components';
import { Card } from 'antd';

export const ReservationWrapper = styled('div')`
.ant-form .ant-form-item .ant-form-item-label, .ant-form .ant-form-item .ant-form-item-control {
    display: flex;
}
`;

export const ReservationFormWrapper = styled(Card)`
&&&& {
    @media only screen and (min-width: 600px) {
    display :flex ;
}}
`;